import { render, staticRenderFns } from "./OdpInformation.vue?vue&type=template&id=6a8b0822&scoped=true&"
import script from "./OdpInformation.vue?vue&type=script&lang=ts&"
export * from "./OdpInformation.vue?vue&type=script&lang=ts&"
import style0 from "./OdpInformation.vue?vue&type=style&index=0&id=6a8b0822&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b0822",
  null
  
)

export default component.exports